import { cn } from '@/lib/utils'

// A small dot on a place where something waits for you (someone asking to connect, on People). Never a count.
export function WaitingDot({ className }: { className?: string }) {
  return (
    <span className={cn('inline-block size-2 shrink-0 rounded-full bg-warm ring-2 ring-background', className)}>
      <span className="sr-only">, someone wants to connect</span>
    </span>
  )
}
